import { c as _c } from "react/compiler-runtime";
import { FC } from 'react';
import { BlogPostDto } from '@/components/BlogPage/types';
import JsonLdScript from '@/components/json-ld/JsonLdScript';
import { buildBlogPostingJsonLd } from '@/lib/blog-posting-schema';
interface Props {
  post: BlogPostDto;
}
const BlogPostingJsonLd: FC<Props> = t0 => {
  const $ = _c(4);
  const {
    post
  } = t0;
  let t1;
  if ($[0] !== post) {
    t1 = buildBlogPostingJsonLd(post);
    $[0] = post;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <JsonLdScript data={t1} />;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default BlogPostingJsonLd;